import { getIn } from 'formik';
import styled from 'styled-components/macro';
import { FieldErrorIndicator } from '../../shared/form/FieldErrorIndicator';
import { fontWeightMedium } from '../../styling/fonts';
import { spacing01 } from '../../styling/spacing';
import { QuantityTh } from './BillOfMaterialsItemsTable';

export const quantityColumnErrorMessage = 'Quantity must be a whole number greater than 0';

const quantityColumnTooltipId = (fieldArrayName: string) => `quantity-column-${fieldArrayName}`;

export type QuantityColumnHeaderProps = {
  fieldArrayName: string;
  errors: unknown;
};

export const QuantityColumnHeader = ({ fieldArrayName, errors }: QuantityColumnHeaderProps) => {
  const rowErrors: Array<{ quantity?: string } | undefined> = getIn(errors, fieldArrayName) ?? [];
  const hasError = rowErrors.some(rowError => rowError?.quantity != null);

  return (
    <QuantityTh>
      <QuantityHeaderContainer>
        Quantity
        <ErrorIndicator
          fieldName={fieldArrayName}
          showError={hasError}
          error={quantityColumnErrorMessage}
          tooltipId={quantityColumnTooltipId(fieldArrayName)}
        />
      </QuantityHeaderContainer>
    </QuantityTh>
  );
};

const QuantityHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .__react_component_tooltip {
    text-transform: none;
    letter-spacing: normal;
    font-weight: ${fontWeightMedium};
  }
`;

const ErrorIndicator = styled(FieldErrorIndicator)`
  margin: 0 ${spacing01};
`;
